import * as _ from "lodash";


export const shortenProcessorItemType = (type: string) => shortenJsonCSharpType(type,"ProcessorItem");

export const shortenProcessorItemErrorType = (type: string) => shortenJsonCSharpType(type,"ProcessorItem");

const shortenJsonCSharpType = (type: string,prefixToStripOut: string): string => 
{
    const characterAtEndOfTypeName = _.includes(type,"`") ?  "`" : ","; // ` if class  has a generic type // , if class does not have a generic type 
    
    const a = _.split(type,characterAtEndOfTypeName)[0];
    const b = _.split(a,".");
    const c = b[b.length - 1];
    
    return  _.replace(c,prefixToStripOut,"");
}

type GroupedProcessorItems = {
    [key:string]: ProcessorItem[]
};

type GroupedProcessorItemsResult = {
    typesGroupedByShortType: {[key:string]: string[]},
    itemsGroupedByShortType: GroupedProcessorItems
}

export const groupProcessorItems = (items: ProcessorItem[]): GroupedProcessorItemsResult => {
    
    const itemsGroupedByType = _.groupBy(items,i => i.$type);
    const typesGroupedByShortType = _.groupBy(_.keys(itemsGroupedByType),grouping => shortenProcessorItemType(grouping));

    const groupedProcessorItems = _.keys(typesGroupedByShortType).reduce<GroupedProcessorItems>((acc: GroupedProcessorItems, shortType) => {

        acc[shortType] = typesGroupedByShortType[shortType].reduce<ProcessorItem[]>((acc: ProcessorItem[], type: string) => {
            return _.concat(acc, itemsGroupedByType[type]);
        }, []);

        return acc;
    }, {});

    return {
        typesGroupedByShortType: typesGroupedByShortType,
        itemsGroupedByShortType: groupedProcessorItems
    };
}

export interface ProcessorItem {
    [key: string]: any;
    
    $id: string;
    $type: string;

    misItem: any,
    sdsRow: any,
    error: boolean,
    errors: AnyProcessorItemError[]
}

export interface ProcessorItemError
{
    [key: string]: any;

    message: string;
    help: string;
}

export interface CustomerError extends ProcessorItemError {
    name: string;
    username: string;
}

export interface ProcessorItemStepError extends ProcessorItemError
{
    step: string;
}

export interface ProcessorItemStepException extends ProcessorItemStepError
{
    exceptionMessage: string;
}

export interface ProcessorItemFieldError extends ProcessorItemStepError
{
    field: string;
}

export type AnyProcessorItemError = ProcessorItemError & ProcessorItemStepError & ProcessorItemStepException & ProcessorItemFieldError